import {DAILY_PROMO_INTERVAL_MS, createDailyPromoStorage} from './dailyPromoStorage';

// Приглашение в первый бой с ботами — локальную партию (BotMatchPromoModal в
// главном меню). Две отметки в localStorage:
//
// 1. «Обучение только что пройдено» (pending): ставится в момент первого
//    прохождения последней главы, снимается, когда игрок закрыл приглашение
//    в меню. Пока отметка стоит, приглашение показывается без оглядки на
//    суточную паузу — это тот самый первый показ сразу после обучения.
//    Игрок, нажавший «В битву» прямо на поздравлении, до меню с этой отметкой
//    дойдет уже с сыгранной партией — и приглашения не увидит.
// 2. Дата последнего закрытия (см. dailyPromoStorage): повторные показы, пока
//    игрок так и не сыграл ни одного матча, — не чаще раза в сутки

export const BOT_MATCH_PROMO_PENDING_STORAGE_KEY = 'botMatchPromoPending';
export const BOT_MATCH_PROMO_SHOWN_AT_STORAGE_KEY = 'botMatchPromoShownAt';

export const BOT_MATCH_PROMO_INTERVAL_MS = DAILY_PROMO_INTERVAL_MS;

const dailyStorage = createDailyPromoStorage(BOT_MATCH_PROMO_SHOWN_AT_STORAGE_KEY);

export const checkIfBotMatchPromoDue = dailyStorage.checkIfDue;
export const rememberBotMatchPromoShown = dailyStorage.rememberShown;

/**
 * Обучение только что пройдено, а приглашение игрок еще не видел.
 * Недоступный localStorage (Safari в приватном режиме) — считаем, что отметки
 * нет: без нее приглашение все равно покажется по обычному правилу (матчей
 * нет вовсе, суточная пауза прошла)
 */
export const checkIfBotMatchPromoPending = () => {
  try {
    return window.localStorage.getItem(BOT_MATCH_PROMO_PENDING_STORAGE_KEY) === '1';
  } catch (e) {
    return false;
  }
};

/**
 * Отметить первое прохождение последней главы обучения: следующий заход в
 * главное меню откроет приглашение в бой с ботами (см.
 * TutorialChapterCompleteModal)
 */
export const markBotMatchPromoPending = () => {
  try {
    window.localStorage.setItem(BOT_MATCH_PROMO_PENDING_STORAGE_KEY, '1');
  } catch (e) {
    // Работаем без localStorage: приглашение покажется по обычному правилу
  }
};

export const clearBotMatchPromoPending = () => {
  try {
    window.localStorage.removeItem(BOT_MATCH_PROMO_PENDING_STORAGE_KEY);
  } catch (e) {
    // Без localStorage снимать нечего
  }
};
